// extracted by mini-css-extract-plugin
module.exports = {"root":"_939bbe0","title":"_cf6f922","left":"_20d8293","right":"_f790a52","content":"_babb318"};